export default __webpack_public_path__ + "static/media/kitchen3-after3-768w.2b2bc9c3.png";